import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));

export default function ItemsMovementTotalTable(props) {
    const { data, rptParams,subUnit } = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 16,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#000"
    }

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#3f51b5" ,
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 17,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {t("no")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("item")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("cost")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("opening_balance")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("purchases")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("return_purchase")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("sales")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("return_sale")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("supply")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("exchange")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("transference")}
                        </TableCell> <TableCell style={stylH} align="center">
                            {t("receiving")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("settlement")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("balance")}
                        </TableCell> <TableCell style={stylH} align="center">
                            {t("total_cost")}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, i) => (
                        <TableRow key={row.Name_Trans}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 17,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center">{row.item_ID}</TableCell>
                            <TableCell style={stylRo} align="center">{row.currName}</TableCell>

                            <TableCell style={stylRo} align="center">{parseFloat(row.cost).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.initial/rptParams.subUnit?.perc).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Buyment/rptParams.subUnit?.perc).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.ReBuyment/rptParams.subUnit?.perc).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row?.Sales/rptParams.subUnit?.perc).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row?.ReSales/rptParams.subUnit?.perc)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Twreed/rptParams.subUnit?.perc)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Sarf/rptParams.subUnit?.perc)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Tahweel/rptParams.subUnit?.perc)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Estelam/rptParams.subUnit?.perc)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.tsweya/rptParams.subUnit?.perc)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Blc/rptParams.subUnit?.perc)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{row.TotalCost?.toFixed(2)}</TableCell>





                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
